import Intercom from '@intercom/messenger-js-sdk';

import { session } from '@/globals//session';
import { i18n } from '@/i18n/i18n';
import { accountService } from '@/services/accounts';

let isPreparingIntercom = false;
let isInitialized = false;

function isEnabled() {
  return (
    session.account &&
    session.account.role == 'admin' &&
    session.institution &&
    session.institution.brand == 'zeitstrom'
  );
}

function isIntercomLoaded() {
  return typeof window.Intercom === 'function';
}

function load() {
  if (isIntercomLoaded()) return;
  if (!session.account || !session.institution) return;

  Intercom({
    app_id: 'w7h8y7gn',
    user_id: session.account.id,
    name: session.account.full_name,
    email: session.account.email,
    ...(session.account.support_jwt ? { intercom_user_jwt: session.account.support_jwt } : {}),

    company: {
      company_id: session.institution.id,
      created_at: Math.floor(new Date(session.institution.created_at).getTime()),
      name: session.institution.name,
      plan: session.institution.plan,
      website: 'https://app.zeit.work/staff/institutions/?q=' + session.institution.name,
    },

    auth_tokens: {
      ...(localStorage.accessToken ? { access_token: localStorage.accessToken } : {}),
    },


    created_at: Math.floor(new Date(session.account.created_at).getTime()),
    language_override: i18n.global.locale,
    hide_default_launcher: true,
  });
  console.log('Intercom loaded');

}

async function reloadAccountBeforeBoot() {
  if (!session.account) return;

  try {
    await accountService.reloadCurrentAccount();
  } catch (error) {
    console.log('Could not refresh account before Intercom init', error);
  }
}

function shutdown() {
  if (!isIntercomLoaded()) return;

  if (window.Intercom === undefined) return;
  window.Intercom('shutdown');
  window.Intercom = undefined;
}

async function handleIntercomVisibility() {
  if (!isEnabled()) {
    shutdown();
    return;
  }

  if (isIntercomLoaded() || isPreparingIntercom) return;

  isPreparingIntercom = true;
  try {
    await reloadAccountBeforeBoot();
    if (isEnabled()) load(); else shutdown();
  } finally {
    isPreparingIntercom = false;
  }
}

export function showIntercom() {
  if (!isIntercomLoaded()) {
    console.log('Intercom not loaded, skipping show()');
    return;
  }

  console.log('Showing Intercom');
  window.Intercom('show');
}

export function showIntercomWithProductTour(productTourId: string) {
  if (!isIntercomLoaded()) {
    console.log('Intercom not loaded, skipping show()');
    return;
  }

  console.log('Showing Intercom with product tour ' + productTourId);
  setTimeout(() => window.Intercom('startTour', productTourId), 1000);
}

export async function initIntercom() {
  if (!isInitialized) {
    session.on('change', handleIntercomVisibility);
    session.on('reset', shutdown);
    isInitialized = true;
  }

  await handleIntercomVisibility();
}
